import { CallId, UtcTime } from 'shared/models';
import moment from 'moment';

export function makeCallArchiveFilename(callId: CallId, externalId: string | null, elevatorName: string | null, created: UtcTime): string {
    const safeExternalId = externalId ? externalId.replace(/[^a-zA-Z0-9]/g, '-').replace(/--+/g, '-').replace(/^-|-$/g, '') : '';
    const safeElevatorName = elevatorName ? elevatorName.replace(/[^a-zA-Z0-9]/g, '-').replace(/--+/g, '-').replace(/^-|-$/g, '') : '';
    const timestamp = moment.utc(created).format('YYYYMMDD_HHmmssSSS');
    return `${safeExternalId}_${safeElevatorName}_#${callId}_${timestamp}.zip`;
}
